<div class="pt-4">
    <h3>{{ 'project' | transloco: { COUNT: projects().length } }}</h3>
    @for (project of projects(); track project.id) {
        <div class="flex pr-4 py-1">
            <fa-icon
                class="mr-2"
                [icon]="['fas', 'circle']"
                [ngStyle]="{ color: project.color }" />
            <span>{{ project.name }}</span>
        </div>
    } @empty {
        <span class="pt-10 light-text break-words">{{ 'notUsedInAnyProject' | transloco }}</span>
    }

    @if (managementDataService.currentView() === DataViewType.ORGANIZATION_DATA) {
        <app-deposit-validation [deposit]="deposit()" />
    }

    @if (deposit()?.standard) {
        <div class="pt-8">
            <app-entity-link-document-list
                [areDocumentsLost]="true"
                [data]="documentData()"
                [subTitle]="'documentLostSubtitle'" />
        </div>
    }

    @if (metadataInformation()) {
        <app-deposit-metadata-information [metadataInformation]="metadataInformation()!" />
    }
</div>
